import { Palette } from '@mui/material';

import { AvailabilityTone } from '@utils';

export const availabilityDotColor = (
  palette: Palette,
): Record<AvailabilityTone, string> => ({
  now: palette.highlight.scoreGreen,
  soon: palette.highlight.scoreYellow,
  neutral: palette.background.dividerStrong,
});
